// @flow

/***IMPORT SVG****/
import Broom from 'AssetsRoot/images/cleaning.svg.react';
import IconTv from 'AssetsRoot/images/show/noun_TV.svg.react';
import Palmas from 'AssetsRoot/images/homie_v3/palmas.svg.react';
import MexIcon from 'AssetsRoot/images/homie_v3/mexico_flag.svg.react';
import USAIcon from 'AssetsRoot/images/homie_v3/united_states_flag.svg.react';
import IconIdea from 'AssetsRoot/images/show/noun_Idea.svg.react';
import IconWifi from 'AssetsRoot/images/show/noun_wifi.svg.react';
import IconDrop from 'AssetsRoot/images/show/noun_drop.svg.react';
import OxxoLogo from 'AssetsRoot/images/homie_v3/oxxo.svg.react';
import IconHeart from 'AssetsRoot/images/favorite_heart.svg.react';
import IconClose from 'AssetsRoot/images/close.svg.react';
import FilterSVG from 'AssetsRoot/images/filter.svg.react';
import DownArrow from 'AssetsRoot/images/double-down-arrow.svg.react';
import emailIcon from 'AssetsRoot/images/homie_v3/Mail_black.svg.react';
import IconLogin from 'AssetsRoot/images/homie_v3/login.svg.react';
import CheckGreen from 'AssetsRoot/images/homie_v3/check_green.svg.react';
import TwitterLogo from 'AssetsRoot/images/homie_v3/services/twitter-logo.svg.react';
import PinMapShape from 'AssetsRoot/images/PinMapShape.svg.react';
import IconBubbles from 'AssetsRoot/images/show/noun_bubbles.svg.react';
import IconQuestion from 'AssetsRoot/images/homie_v3/payments/question.svg.react';
import IconNotFound from 'AssetsRoot/images/homie_v3/Error404.svg.react';
import IconCheckMark from 'AssetsRoot/images/check-mark.svg.react';
import NarrowedHands from 'AssetsRoot/images/homie_v3/narrowed_hands.svg.react';
import UpArrowSimple from 'AssetsRoot/images/homie_v3/up_arrow.svg.react';
import IconTemperature from 'AssetsRoot/images/show/noun_Temperature.svg.react';
import DownArrowSimple from 'AssetsRoot/images/homie_v3/down_arrow.svg.react';
import IconFbMessenger from 'AssetsRoot/images/homie_v3/fbmessengerfooter.svg.react';
import IconFacebook from 'AssetsRoot/images/homie_v3/facebookFooter.svg.react';
import IconTwitter from 'AssetsRoot/images/homie_v3/twitterFooter.svg.react';
import IconLinkedIn from 'AssetsRoot/images/homie_v3/linkedInFooter.svg.react';
import IconInstagram from 'AssetsRoot/images/homie_v3/instagramFooter.svg.react';
import DownArrowSimplePurple from 'AssetsRoot/images/homie_v3/down_arrow_purple.svg.react';
import IconQuestionWhitePurple from 'AssetsRoot/images/homie_v3/payments/question_white_purple.svg.react';
import TalkIcon from 'AssetsRoot/images/homie_v3/onboarding/icons/talk.svg.react';
import ZoomIcon from 'AssetsRoot/images/homie_v3/onboarding/icons/zoom.svg.react';
import OwnerSVG from 'AssetsRoot/images/homie_v3/propietario.svg.react';
import PictureIcon from 'AssetsRoot/images/homie_v3/picture_icon.svg.react';
import IdCardPicture from 'AssetsRoot/images/homie_v3/id_card.svg.react';
import MountainsIcon from 'AssetsRoot/images/homie_v3/onboarding/icons/mountains.svg.react';
import WriteIcon from 'AssetsRoot/images/homie_v3/onboarding/icons/write.svg.react';
import PayIcon from 'AssetsRoot/images/homie_v3/onboarding/icons/pay.svg.react';
import LawIcon from 'AssetsRoot/images/homie_v3/onboarding/icons/law.svg.react';
import LawfulIcon from 'AssetsRoot/images/homie_v3/onboarding/icons/lawful.svg.react';
import LandscapeIcon from 'AssetsRoot/images/homie_v3/onboarding/icons/landscape_phone.svg.react';
import LivinRoomIcon from 'AssetsRoot/images/homie_v3/onboarding/icons/living_room.svg.react';
import CameraGuyIcon from 'AssetsRoot/images/homie_v3/onboarding/icons/camera_guy.svg.react';
import WindowIcon from 'AssetsRoot/images/homie_v3/onboarding/icons/window.svg.react';
import RoomIcon from 'AssetsRoot/images/homie_v3/onboarding/icons/room.svg.react';
import CityImageIcon from 'AssetsRoot/images/homie_v3/onboarding/city_image.svg.react';
import ClockSVG from 'AssetsRoot/images/homie_v3/clock.svg.react';
import GreenCheckIcon from 'AssetsRoot/images/check.svg.react';
//import TercerosSVG from 'AssetsRoot/images/homie_v3/terceros.svg.react';
/***END IMPORT SVG***/

import TimesSVG from 'AssetsRoot/images/homie_v3/homes/features/times.svg.react';
import LogoSVG from 'AssetsRoot/images/logos2.0/homie.svg.react';
import FavoriteHeartSVG from 'AssetsRoot/images/favorite_heart.svg.react';
import CalendarSVG from 'AssetsRoot/images/calendar_dates.svg.react';
import HomeSVG from 'AssetsRoot/images/home_mini_logo_red.svg.react';
import PaymentsSVG from 'AssetsRoot/images/pagos.svg.react';
import H360WhiteImg from 'AssetsRoot/images/logos2.0/h360_white.png';
import H360Banner from 'AssetsRoot/images/h360/h360_banner.jpg';
import AdvisorBanner from 'AssetsRoot/images/h360/advisor_guia_banner.jpg';
import HomieFooter from 'AssetsRoot/images/h360/homie_footer.svg.react';
import FacebookFooter from 'AssetsRoot/images/h360/facebook_footer.svg.react';
import TwitterFooter from 'AssetsRoot/images/h360/twitter_footer.svg.react';
import InstagramFooter from 'AssetsRoot/images/h360/instagram_footer.svg.react';
import H360RedImg from 'AssetsRoot/images/h360/homie_h360.svg.react';
import AdvisorBannerGuia from 'AssetsRoot/images/h360/advisor_guia_banner.jpg';
import AdvisorBannerBeGrand from 'AssetsRoot/images/h360/advisor_be_grand_banner.jpg';
import BeGrandLogo from 'AssetsRoot/images/h360/logo_be_grand.svg.react';
import GuiaLogo from 'AssetsRoot/images/h360/logo_guia.svg.react';
import Exposition from 'AssetsRoot/images/h360/productivity.svg.react';
import ExpositionRebranding from 'AssetsRoot/images/h360/productivity_rebranding.svg.react';
import Quotes from 'AssetsRoot/images/h360/group.svg.react';
import QuotesRebranding from 'AssetsRoot/images/h360/group_rebranding.svg.react';
import Tenants from 'AssetsRoot/images/h360/child.svg.react';
import TenantsRebranding from 'AssetsRoot/images/h360/child_rebranding.svg.react';
import RentPayment from 'AssetsRoot/images/h360/transferMoney.svg.react';
import RentPaymentRebranding from 'AssetsRoot/images/h360/transferMoney_rebranding.svg.react';
import Administration from 'AssetsRoot/images/h360/mobilePayments.svg.react';
import AdministrationRebranding from 'AssetsRoot/images/h360/mobilePayments_rebranding.svg.react';
import LegalProtection from 'AssetsRoot/images/h360/judge.svg.react';
import LegalProtectionRebranding from 'AssetsRoot/images/h360/judge_rebranding.svg.react';
import DecorateLeft from 'AssetsRoot/images/h360/decorateLeft.png';
import DecorateRight from 'AssetsRoot/images/h360/decorateRight.png';
import Approved from 'AssetsRoot/images/h360/approved_circle.svg.react';
import Rejected from 'AssetsRoot/images/h360/rejected_circle.svg.react';
import Professional from 'AssetsRoot/images/product_seeker/professional.png';
import Fee from 'AssetsRoot/images/product_seeker/fee.png';
import Logo from 'AssetsRoot/images/homie_v3/logo-homie.svg.react';
import H360HomieLogo from 'AssetsRoot/images/homie_v3/logo-homie-h360.svg.react';

export const HeaderIcons = {
  LogoSVG: LogoSVG,
  Logo: Logo,
  FavoriteHeartSVG: FavoriteHeartSVG,
  CalendarSVG: CalendarSVG,
  HomeSVG: HomeSVG,
  PaymentsSVG: PaymentsSVG,
  DownArrow: DownArrowSimple
};

export const CountryFlags = {
  MexicoIcon: MexIcon,
  USAIcon: USAIcon
};

export const HeaderUtil = {
  appIcon: '/assets/homie_v3/application.svg',
  messageIcon: '/assets/homie_v3/message.jpeg'
};

export const Onboarding = {
  PictureIcon: PictureIcon,
  IdCardPicture: IdCardPicture,
  Mountains: MountainsIcon,
  CameraGuy: CameraGuyIcon,
  LandscapePhone: LandscapeIcon,
  LivinRoom: LivinRoomIcon,
  Window: WindowIcon,
  Room: RoomIcon,
  TalkOnboarding: TalkIcon,
  LawOnboarding: LawIcon,
  PayOnboarding: PayIcon,
  WriteOnboarding: WriteIcon,
  ZoomOnboarding: ZoomIcon,
  CityImage: CityImageIcon,
  Clock: ClockSVG,
  LawfulOnboarding: LawfulIcon,
  GreenCheck: GreenCheckIcon
};

export const HomeApplication = {
  SadFace: '/assets/icons/sad_face_emoji.png',
  ThinkingFace: '/assets/icons/thinking_face_emoji.png'
};

export const BrowsersLogo = {
  Firefox: '/assets/browsers/firefox_logo.png',
  Chrome: '/assets/browsers/chrome_logo.png',
  Safari: '/assets/browsers/safari_logo.png'
};

export const NewspaperIcon = {
  IconReforma: '/assets/footer/reforma.svg',
  IconUniversal: '/assets/footer/universal.svg',
  IconMilenio: '/assets/footer/milenio.svg',
  IconExpasion: '/assets/footer/expansion.svg',
  IconForbes: '/assets/footer/forbes.svg',
  IconFinanciero: '/assets/footer/financiero.svg'
};

export const SocialNetworks = {
  Facebook: '/assets/iconos-homie/homes_show/fb@2x.png',
  Twitter: '/assets/iconos-homie/homes_show/tw@2x.png'
};

export const IconsFeaturesAmenities = {
  IconFurnished: '/assets/sofa.svg',
  IconFurnishedWhite: '/assets/sofaWhite.svg',
  IconFurnishedColor: '/assets/sofaColor.svg',
  IconGardenDark: '/assets/homie_v3/homes/features/garden.svg',
  IconGardenLight: '/assets/homie_v3/homes/features/garden_color.svg',
  IconBalconyLight: '/assets/homie_v3/homes/features/balcony_color.svg',
  IconBalconyDark: '/assets/homie_v3/homes/features/balcony.svg',
  IconSecurityLight: '/assets/homie_v3/homes/features/security_color.svg',
  IconSecurityDark: '/assets/homie_v3/homes/features/security.svg',
  IconGymDark: '/assets/homie_v3/homes/features/gym.svg',
  IconGymLight: '/assets/homie_v3/homes/features/gym_color.svg',
  IconCisternDark: '/assets/homie_v3/homes/features/cistern.svg',
  IconCisternLight: '/assets/homie_v3/homes/features/cistern_color.svg',
  IconRoasterDark: '/assets/homie_v3/homes/features/roaster.svg',
  IconRoasterLight: '/assets/homie_v3/homes/features/roaster_color.svg',
  IconJacuzzyDark: '/assets/homie_v3/homes/features/jacuzzy.svg',
  IconJacuzzyLight: '/assets/homie_v3/homes/features/jacuzzy_color.svg',
  IconLobbyDark: '/assets/homie_v3/homes/features/lobby.svg',
  IconLobbyLight: '/assets/homie_v3/homes/features/lobby_color.svg',
  IconSaunaDark: '/assets/homie_v3/homes/features/sauna.svg',
  IconSaunaLight: '/assets/homie_v3/homes/features/sauna_color.svg',
  IconPoolDark: '/assets/homie_v3/homes/features/pool.svg',
  IconPoolLight: '/assets/homie_v3/homes/features/pool_color.svg',
  IconGamesDark: '/assets/homie_v3/homes/features/games.svg',
  IconGamesLight: '/assets/homie_v3/homes/features/games_color.svg',
  IconElevatorDark: '/assets/homie_v3/homes/features/elevator.svg',
  IconElevatorLight: '/assets/homie_v3/homes/features/elevator_color.svg',
  IconEventRoomsDark: '/assets/homie_v3/homes/features/events_room.svg',
  IconEventRoomsLight: '/assets/homie_v3/homes/features/events_room_color.svg',
  IconGreenAreasDark: '/assets/homie_v3/homes/features/green_areas.svg',
  IconGreenAreasLight: '/assets/homie_v3/homes/features/green_areas_color.svg',
  IconServicesRoomDark: '/assets/homie_v3/homes/features/service_room.svg',
  IconServicesRoomLight:
    '/assets/homie_v3/homes/features/service_room_color.svg',
  IconCinemaDark: '/assets/homie_v3/homes/features/cinema.svg',
  IconCinemaLight: '/assets/homie_v3/homes/features/cinema_color.svg',
  IconBolicheDark: '/assets/homie_v3/homes/features/boliche.svg',
  IconBolicheLight: '/assets/homie_v3/homes/features/boliche_color.svg',
  IconTennisCourtDark: '/assets/homie_v3/homes/features/tennis_court.svg',
  IconTennisCourtLight:
    '/assets/homie_v3/homes/features/tennis_court_color.svg',
  IconSquashDark: '/assets/homie_v3/homes/features/squash.svg',
  IconSquashLight: '/assets/homie_v3/homes/features/squash_color.svg',
  IconVisitsSpaceDark: '/assets/homie_v3/homes/features/visits_space.svg',
  IconVisitsSpaceLight:
    '/assets/homie_v3/homes/features/visits_space_color.svg',
  IconWashingStationDark: '/assets/homie_v3/homes/features/washing_station.svg',
  IconWashingStationLight:
    '/assets/homie_v3/homes/features/washing_station_color.svg',
  IconAirConditionerDark: '/assets/homie_v3/homes/features/air_conditioner.svg',
  IconAirConditionerLight:
    '/assets/homie_v3/homes/features/air_conditioner_color.svg',
  IconPlaygroundDark: '/assets/homie_v3/homes/features/playground.svg',
  IconPlaygroundLight: '/assets/homie_v3/homes/features/playground_color.svg',
  IconHeatingDark: '/assets/homie_v3/homes/features/heating.svg',
  IconHeatingLight: '/assets/homie_v3/homes/features/heating_color.svg',
  IconIntegralKitchenDark:
    '/assets/homie_v3/homes/features/integral_kitchen.svg',
  IconIntegralKitchenLight:
    '/assets/homie_v3/homes/features/integral_kitchen_color.svg',
  IconUniversalAccessDark:
    '/assets/homie_v3/homes/features/universal_access.svg',
  IconUniversalAccessLight:
    '/assets/homie_v3/homes/features/universal_access_color.svg',
  IconPetFriendlyDark: '/assets/homie_v3/homes/features/pet_friendly_dark.svg',
  IconPetFriendlyWhite:
    '/assets/homie_v3/homes/features/pet_friendly_white.svg',
  IconClubWhite: '/assets/homie_v3/homes/features/club_white.svg',
  IconClubDark: '/assets/homie_v3/homes/features/club_dark.svg',
  IconWashingStationSelect:
    '/assets/homie_v3/homes/features/washing_station_select.svg',
  IconPetFriendlySelect:
    '/assets/homie_v3/homes/features/pet_friendly_select.svg',
  ClubSelect: '/assets/homie_v3/homes/features/club_select.svg',
  IconTerrace: '/assets/homie_v3/homes/features/Terraza.svg',
  IconTerraceColor: '/assets/homie_v3/homes/features/TerrazaColor.svg',
  IconPetsFriendlyColor:
    '/assets/homie_v3/homes/features/pets_friendly_color.svg',
  IconPetsFriendlyDark:
    '/assets/images/homie_v3/homes/features/pets_friendly.svg',
  IconShowFurnished: '/assets/homie_v3/homes/features/show_furnished.svg',
  IconShowFloor: '/assets/homie_v3/homes/features/floors.svg'
};

export const Common = {
  CheckMapDark: '/assets/homie_v3/map/check_map_dark.svg',
  CheckMapLight: '/assets/homie_v3/map/check_map_light.png',
  HelpMap: '/assets/homie_v3/map/help_map.svg',
  MarkerIconWhite: '/assets/maps-icons/rectangle-purple-white.svg',
  MarkerIconPurple: '/assets/maps-icons/rectangle-purple.svg',
  MarkerIconHomieColor: '/assets/maps-icons/rectangle-red-homie.svg',
  MarkerIconHomieColorCluster:
    '/assets/maps-icons/rectangle-red-homie-cluster.svg',
  MarkerIconPurpleCluster: '/assets/maps-icons/rectangle-purple-cluster.svg',
  testSelect: '/assets/tempTestImageSelect.png',
  DownArrowDark: '/assets/images/down_arrow.svg',
  IconShape: '/assets/Shape.svg',
  IconTv: IconTv,
  IconBubbles: IconBubbles,
  IconIdea: IconIdea,
  IconTemperature: IconTemperature,
  IconWifi: IconWifi,
  IconDrop: IconDrop,
  IconHeart: IconHeart,
  IconClose: IconClose,
  IconLogin: IconLogin,
  IconUser: '/assets/homie_v3/user_icon.png',
  IconCheckMark: IconCheckMark,
  ChildSuccess: '/assets/thumbs.gif',
  VisaCardLogo: '/assets/homie_v3/visa.png',
  MasterCardLogo: '/assets/homie_v3/mastercard.png',
  AmexCardLogo: '/assets/homie_v3/amex.png',
  OxxoLogo: OxxoLogo,
  CheckGreen: '/assets/homie_v3/check_green.svg.react',
  CheckGreenSVG: CheckGreen,
  CheckGreenCircle: '/assets/homie_v3/check_green_circle.png',
  Palmas: Palmas,
  UpArrowSimple: UpArrowSimple,
  mailIcon: emailIcon,
  PinShape: '/assets/PinShape.svg',
  PinMapShape: PinMapShape,
  AjaxLoader: '/assets/ajax-loader.gif',
  TenantHomeNotFound: '/assets/tenant-home-not-found.svg',
  PDFIcon: '/assets/homie_v3/home_applications/pdf-icon.png',
  DropDownArrow: '/assets/homie_v3/dropdown_arrow.svg',
  BackArrow: '/assets/homie_v3/back_arrow.png',
  ClockIcon: '/assets/homie_v3/clock.png'
};

export const ModalFilterIcon = {
  ImageBG: '/assets/modalCover.jpeg',
  Broom: Broom,
  FilterSVG: FilterSVG,
  DownArrow: DownArrow
};

export const Auth = {
  cover: '/assets/signinCover.jpg',
  sign_up: '/assets/homie_v3/auth/sign_up.png',
  wsapp: '/assets/homie_v3/auth/wapp.svg',
  WelcomeCover: '/assets/homie_v3/auth/jezael-melgoza-250810-unsplash.png',
  propietario: OwnerSVG
  //terceros: TercerosSVG
};

export const Appointment = {
  Times: TimesSVG
};

export const DashboardHome = {
  downArrow: DownArrowSimple,
  home: '/assets/homie_v3/auth/Foto.png',
  mouse: '/assets/homie_v3/auth/noun_mouse.svg'
};

export const ServicesIcons = {
  iconTwitter: TwitterLogo
};

export const IconsPayment = {
  IconQuestion: IconQuestion,
  IconQuestionWhitePurple: IconQuestionWhitePurple
};

export const ReportIcon = {
  downArrow: DownArrowSimple,
  DownArrowSimplePurple: DownArrowSimplePurple
};

export const IconsRenewContract = {
  NarrowedHandsSVG: NarrowedHands
};

export const NotFound = {
  IconNotFound: IconNotFound
};

export const IconsFooter = {
  IconFbMessenger: IconFbMessenger,
  IconFacebook: IconFacebook,
  IconTwitter: IconTwitter,
  IconLinkedIn: IconLinkedIn,
  IconInstagram: IconInstagram
};

export const PaginatedDataAssets = {
  RightArrow: '/assets/grey-right-arrow.svg',
  LeftArrow: '/assets/grey-left-arrow.svg'
};

export const LegalAssets = {
  UpArrow: '/assets/up-arrow-black.svg',
  WhiteUpArrow: '/assets/up-arrow-white.svg'
};

export const AdvisorAssets = {
  LogoBlank: '/assets/advisors/rg_blank_logo.png',
  cover: '/assets/advisors/cover.jpg',
  HomieTech: '/assets/advisors/homie_tech.svg',
  AdvisorOwnerDarkGray: '/assets/advisors/advisor_owner_dark_gray.svg',
  AdvisorOwnerGray: '/assets/advisors/advisor_owner_gray.svg',
  AdvisorHomeGray: '/assets/advisors/advisor_home_gray.svg',
  AdvisorHomeDarkGray: '/assets/advisors/advisor_home_dark_gray.svg',
  AdvisorTenantGray: '/assets/advisors/advisor_tenant_gray.svg',
  AdvisorTenantDarkGray: '/assets/advisors/advisor_tenant_dark_gray.svg',
  GuarantorProfileGray: '/assets/advisors/guarantor_profile.svg',
  GuarantorProfileDarkGray: '/assets/advisors/guarantor_profile_dark_gray.svg',
  GuarantorPropertyGray: '/assets/advisors/guarantor_property.svg',
  GuarantorPropertyDarkGray:
    '/assets/advisors/guarantor_property_dark_gray.svg',
  GuarantorHomeDocumentGray: '/assets/advisors/guarantor_home_document.svg',
  GuarantorHomeDocumentDarkGray:
    '/assets/advisors/guarantor_home_document_dark_gray.svg',
  GuarantorSpouseDocumentGray: '/assets/advisors/guarantor_spouse_document.svg',
  GuarantorSpouseDocumentDarkGray:
    '/assets/advisors/guarantor_spouse_document_dark_gray.svg',
  GuarantorCoOwnerDocumentGray:
    '/assets/advisors/guarantor_coowner_document.svg',
  GuarantorCoOwnerDocumentDarkGray:
    '/assets/advisors/guarantor_coowner_document_dark_gray.svg',
  TenantProfileGray: '/assets/advisors/tenant_profile.svg',
  TenantProfileDarkGray: '/assets/advisors/tenant_profile_dark_gray.svg',
  TenantIncomeGray: '/assets/advisors/tenant_income.svg',
  TenantIncomeDarkGray: '/assets/advisors/tenant_income_dark_gray.svg',
  TenantReferencesGray: '/assets/advisors/tenant_references.svg',
  TenantReferencesDarkGray: '/assets/advisors/tenant_references_dark_gray.svg',
  TenantPaymentGray: '/assets/advisors/tenant_payment.svg',
  TenantPaymentDarkGray: '/assets/advisors/tenant_payment_dark_gray.svg',
  TenantDocumentsGray: '/assets/advisors/tenant_documents.svg',
  TenantDocumentsDarkGray: '/assets/advisors/tenant_documents_dark_gray.svg',
  SuccessProcessDarkGray: '/assets/advisors/success_process_dark_gray.svg'
};

export const IconsMeero = {
  MeeroLogo: '/assets/icons/meero_logo.svg',
  ThumbsUp: '/assets/icons/thumbs_up.png',
  DefaultImage: '/assets/icons/meero_waiting.png',
  Image: '/assets/homie_v3/onboarding/meero.png'
};

export const ExternalTenantAssets = {
  IndexCover: '/assets/homie_v3/external_tenant/index_cover_image.png',
  IndexCoverMobile:
    '/assets/homie_v3/external_tenant/index_cover_image_mobile.png',
  ApplyBenefit: '/assets/homie_v3/external_tenant/apply.svg',
  PaymentsBenefit: '/assets/homie_v3/external_tenant/payments.svg',
  WarrantyBenefit: '/assets/homie_v3/external_tenant/warranty.svg',
  IntermediaryBenefit: '/assets/homie_v3/external_tenant/intermediary.svg',
  NoPaperworkBenefit: '/assets/homie_v3/external_tenant/no_paperwork.svg'
};

export const CustomerSuccess = {
  calendar: '/assets/homie_v3/customer_success/Calendario.svg',
  cancelMeeting: '/assets/homie_v3/customer_success/Cita-cancelada.png',
  successMeeting: '/assets/homie_v3/customer_success/Cita-aceptada.png',
  organicMeeting: '/assets/homie_v3/customer_success/Cita-organica.svg',
  overdueMeeting: '/assets/homie_v3/customer_success/Timer.svg',
  scheduleAgain: '/assets/homie_v3/customer_success/re-agendado.svg'
};

export const H360 = {
  H360WhiteImg: H360WhiteImg,
  H360Banner: H360Banner,
  AdvisorBanner: AdvisorBanner,
  HomieFooter: HomieFooter,
  FacebookFooter: FacebookFooter,
  TwitterFooter: TwitterFooter,
  InstagramFooter: InstagramFooter,
  Exposition: Exposition,
  Quotes: Quotes,
  Tenants: Tenants,
  RentPayment: RentPayment,
  Administration: Administration,
  LegalProtection: LegalProtection,
  ExpositionRebranding: ExpositionRebranding,
  QuotesRebranding: QuotesRebranding,
  TenantsRebranding: TenantsRebranding,
  RentPaymentRebranding: RentPaymentRebranding,
  AdministrationRebranding: AdministrationRebranding,
  LegalProtectionRebranding: LegalProtectionRebranding,
  DecorateLeft: DecorateLeft,
  DecorateRight: DecorateRight,
  AdvisorBannerBeGrand: AdvisorBannerBeGrand,
  AdvisorBannerGuia: AdvisorBannerGuia,
  H360RedImg: H360RedImg,
  BeGrandLogo: BeGrandLogo,
  GuiaLogo: GuiaLogo,
  Approved: Approved,
  Rejected: Rejected,
  H360HomieLogo: H360HomieLogo
};

export const Navent = {
  logoHomie: '/assets/logos2.0/homie-rosa-200px.png',
  logoInmuebles24: '/assets/navent/Inmuebles_24.svg',
  Fee,
  Professional,
  move: '/assets/navent/move.png'
};

export const AdelantoHomie = {
  banner_first_section:
    '/assets/homie_v3/adelantohomie/banner_first_section.svg',
  logo_homie: '/assets/homie_v3/adelantohomie/logo_homie_black.svg',
  logo_homie_simple: '/assets/homie_v3/adelantohomie/logo_homie_simple.svg',
  logo_homie_white: '/assets/homie_v3/adelantohomie/logo_homie_white.svg',
  logo_homie_purple: '/assets/homie_v3/adelantohomie/logo_homie_purple.svg',
  logo_casa: '/assets/homie_v3/adelantohomie/solid_house.svg',
  logo_ubicacion: '/assets/homie_v3/adelantohomie/solid_location.svg',
  logo_cerradura: '/assets/homie_v3/adelantohomie/solid_lock.svg',
  wave_ilustration: '/assets/homie_v3/adelantohomie/wave_corner.svg',
  right_arrow: '/assets/homie_v3/adelantohomie/right_arrow.svg',
  left_arrow: '/assets/homie_v3/adelantohomie/left_arrow.svg',
  modal_circle_1: '/assets/homie_v3/adelantohomie/modal_circle_1.svg',
  modal_circle_2: '/assets/homie_v3/adelantohomie/modal_circle_2.svg',
  modal_circle_3: '/assets/homie_v3/adelantohomie/modal_circle_3.svg',
  close: '/assets/homie_v3/adelantohomie/close.svg',
  close_gray: '/assets/homie_v3/adelantohomie/close_gray.svg',
  password_hidden: '/assets/homie_v3/adelantohomie/password_hidden.svg',
  password_not_hidden: '/assets/homie_v3/adelantohomie/password_not_hidden.svg',
  question_circle: '/assets/homie_v3/adelantohomie/question_circle.svg',
  return_arrow: '/assets/homie_v3/adelantohomie/return_arrow.svg',
  thumbs_up: '/assets/homie_v3/adelantohomie/thumbs_up.svg',
  green_line: '/assets/homie_v3/adelantohomie/green_line.svg',
  facebook: '/assets/homie_v3/adelantohomie/logo_facebook_white.svg',
  facebook_messenger:
    '/assets/homie_v3/adelantohomie/logo_facebook_messenger_white.svg',
  twitter: '/assets/homie_v3/adelantohomie/logo_twitter_white.svg',
  linkedin: '/assets/homie_v3/adelantohomie/logo_linkedin_white.svg',
  instragram: '/assets/homie_v3/adelantohomie/logo_instagram_white.svg',
  alert_circle: '/assets/homie_v3/adelantohomie/alert_white.svg',
  arrow_left_green: '/assets/homie_v3/adelantohomie/arrow_left_green.svg',
  arrow_right_green: '/assets/homie_v3/adelantohomie/arrow_right_green.svg',
  arrow_left_purple: '/assets/homie_v3/adelantohomie/arrow_left_purple.svg',
  arrow_right_purple: '/assets/homie_v3/adelantohomie/arrow_right_purple.svg',
  feature_process: '/assets/homie_v3/adelantohomie/feature_process.svg',
  feature_rent: '/assets/homie_v3/adelantohomie/feature_rent.svg',
  feature_solicitude: '/assets/homie_v3/adelantohomie/feature_solicitude.svg',
  feature_variety: '/assets/homie_v3/adelantohomie/feature_variety.svg',
  faqs: '/assets/homie_v3/adelantohomie/faqs.svg',
  banner_props: '/assets/homie_v3/adelantohomie/banner_props.png',
  banner_props_mobile: '/assets/homie_v3/adelantohomie/banner_props_mobile.png',
  financiamiento_homie: '/assets/homie_v3/adelantohomie/financiamiento.svg',
  financiamiento_arrow:
    '/assets/homie_v3/adelantohomie/financiamiento_arrow.svg'
};

export const FinancingIcons = {
  warning: '/assets/homie_v3/financing/warning.svg'
};
